import { PaymentMethodDTO, Res } from 'core/api';
import { CashdrawerFacade } from 'pos/facades';
import * as PaymentDTOFactory from './PaymentDTOFactory';
import { Message } from 'core/ui-next/modal';


export type Status = PrepaymentData & PrepaymentResult;

// Datos con los que hago el pago
export type PrepaymentData = {
	Method: PaymentMethodDTO,
	AmountToPay: number;
	PaidAmount: number,
	TipAmount: number,
};

// Resultado de realizar un pago con PaymentData
export type PrepaymentResult = {
	ChangeAmount: number,
	PendingAmount: number,
	ErrorMessage: string,
	ThereIsEnoughChange: boolean
}

async function checkPayment(method: PaymentMethodDTO, amountToPay: number, paidAmount: number, tipAmount: number, isRefund = false): Promise<Status> {
	const result = await CashdrawerFacade.checkPayments([PaymentDTOFactory.create(method, paidAmount, tipAmount)], amountToPay, isRefund);
	return {
		Method: method,
		PendingAmount: result.PendingAmount,
		AmountToPay: result.AmountToPay,
		PaidAmount: result.PaidAmount,
		ChangeAmount: result.ChangeAmount,
		TipAmount: result.TipAmount,
		ErrorMessage: result.ErrorMessage,
		ThereIsEnoughChange: result.ThereIsEnoughChange
	};
}


// OJO: todas las cantidades se tratan siempre en positivo, incluso en el
// caso de devoluciones.

export async function completeTipAmount(current: Status): Promise<Status> {
	// No me puedo basar en el current.changeAmount porque puede haber una forma de pago que permita propina pero no cambio
	const newTip = current.Method.RegisterTip ? Math.max(current.PaidAmount - current.AmountToPay, 0) : 0;
	const newPaidAmount = Math.min(current.AmountToPay, current.PaidAmount);
	return updateChangeAmount({ ...current, TipAmount: newTip }, current.AmountToPay, newPaidAmount);
}

export async function updateChangeAmount(current: Status, amountToPay: number, paidAmount: number): Promise<Status> {
	return await checkPayment(current.Method, amountToPay, paidAmount, current.TipAmount);
}

export async function updateTipAmount(current: Status, tipAmount: number): Promise<Status> {
	return await checkPayment(current.Method, current.AmountToPay, current.PaidAmount, tipAmount);
}

export async function completePaidAmount(current: Status, paidAmount: number): Promise<Status> {
	return await checkPayment(current.Method, current.AmountToPay, paidAmount, current.TipAmount);
}

export async function completeAmountToPay(current: Status, amountToPay: number): Promise<Status> {
	return await checkPayment(current.Method, amountToPay, amountToPay, current.TipAmount);
}

export async function selectedMethod(current: Status, method: PaymentMethodDTO): Promise<Status> {
	return await checkPayment(method, current.AmountToPay, current.PaidAmount, current.TipAmount);
}

export async function check(current: PrepaymentData, isRefund = false): Promise<Status> {
	return await checkPayment(current.Method, current.AmountToPay, current.PaidAmount, current.TipAmount, isRefund);
}

export async function canPay(current: PrepaymentData) {

	const { ErrorMessage, ThereIsEnoughChange } = await check(current);

	if (ErrorMessage) {
		await Message.show(ErrorMessage);
		return false;
	}

	if (!ThereIsEnoughChange) {
		const result = await Message.confirm(Res.Msg.MSG_CONFIRM_NOT_ENOUGH_CASH_TO_GIVE_CHANGE_ON_CLOSE_TICKET());
		if (!result.ok)
			return false;
	}

	return true;
}